import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { CommonService } from 'src/services/common/common.service';
import { SocketService } from 'src/services/socket/socket.service';
@Component({
  selector: 'app-menu-bar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.scss']
})
export class MenuBarComponent implements OnInit {

  /**
   * Creates an instance of menu bar component.
   * @param commonService 
   * @param router 
   */
  constructor(public  commonService: CommonService,
    public router: Router, 
    public socketService: SocketService) { }

  ngOnInit(): void {}

  /**
   * Determines whether url is active
   * @param url 
   * @returns  
   */
  isActive(url: any){
    return this.router.url.split('?')[0] == url
  }

}
